import Vue from 'vue'
import App from './App.vue'
import router from './router'
import OwlCarousel from 'v-owl-carousel'
import VueSmoothScroll from 'vue2-smooth-scroll'
// import VueGtag from "vue-gtag";
import './assets/css/tailwind.css'

Vue.config.productionTip = false
Vue.component('carousel', OwlCarousel)
Vue.use(VueSmoothScroll, {
	duration: 1000,
	updateHistory: false,
	// easingFunction: t => (--t)*t*t+1,
})
// Vue.use(VueGtag, {
//   config: { id: "AW-349698048" }
// });

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
